// extracted by mini-css-extract-plugin
export default {"card_details":"CardDetails_card_details__oO3P8"};